import { getOperationName } from '@apollo/client/utilities';
import { UUID } from '@cmg/common';
import { SnackbarManager } from '@cmg/design-system';
import React from 'react';

import { IndicationStatus } from '../../../../../../../../../graphql';
import {
  Calendar_PublishedOfferingsBuySideDocument,
  Calendar_PublishedOfferingsDocument,
} from '../../../../../../../../calendar/components/calendar-grid/graphql/__generated__';
import { pendingOrderBookGridForcedRefreshVar } from '../../../../../../../../order-book';
import { updateDemandGridRowsReactiveVar } from '../../../../../../../../order-book/institutional-demand/hooks/useUpdateDemandGridRowsReactiveVar';
import { useManageIndication_UpdateIndicationStatusMutation } from '../../../graphql/__generated__';

export const refetchQueries = [
  getOperationName(Calendar_PublishedOfferingsDocument)!,
  getOperationName(Calendar_PublishedOfferingsBuySideDocument)!,
];

export const useUpdateIndicationStatus = (
  offeringId: UUID,
  indicationId: UUID,
  successCallback?: () => void
): [(status: IndicationStatus) => Promise<void>, boolean] => {
  const [updateStatus, { loading: isUpdatingStatus }] =
    useManageIndication_UpdateIndicationStatusMutation();

  const handleUpdateStatus = React.useCallback(
    async (status: IndicationStatus) => {
      try {
        await updateStatus({
          variables: { offeringId, indicationId, status },
          awaitRefetchQueries: true,
          refetchQueries,
        });

        SnackbarManager.success('Successfully updated indication status');
        successCallback?.();
        updateDemandGridRowsReactiveVar({ fetchIds: [indicationId] });
        pendingOrderBookGridForcedRefreshVar(true);
      } catch {
        SnackbarManager.error('Failed to update indication status');
      }
    },
    [indicationId, offeringId, successCallback, updateStatus]
  );

  return [handleUpdateStatus, isUpdatingStatus];
};
